import { Button, ModalsContext } from '@ws/shared/components';
import { CloudArrows20, UploadCloud20 } from '@ws/shared/icons';
import { useContext } from 'react';
import { useSelector } from 'react-redux';

import { TAppState } from '../../../../redux';
import { SyncStatus, TSyncStatusReason } from '../../../../redux/sync';

import { SyncModal } from './SyncModal';

// Человекочитаемый tooltip для PAUSE по причине (§2.8).
const REASON_TOOLTIP: Record<NonNullable<TSyncStatusReason>, string> = {
  offline: 'Офлайн — синхронизация возобновится автоматически',
  hidden: 'Вкладка неактивна',
  'auth-required': 'Нужен вход',
  transport: 'Ожидание сервера',
  'sync-error': 'Ошибка синхронизации',
  'eligibility-error': 'Проблема синхронизации проекта',
  'local-storage-error': 'Ошибка локального хранилища',
};

export function SyncButton() {
  const {
    status: syncStatus,
    isEnabled,
    hydrating,
    reason,
  } = useSelector((state: TAppState) => state.sync.sync);
  const { setModal } = useContext(ModalsContext);

  function handleClick() {
    setModal({
      id: 'sync-modal',
      customView: SyncModal,
    });
  }

  // Пока гидратируется (или синк неизвестен/выключен) — нейтральная иконка.
  if (hydrating || !isEnabled) {
    return (
      <Button
        onClick={handleClick}
        variant="shapeless"
        icon={<UploadCloud20 color="other_grey" />}
      />
    );
  }

  if (syncStatus === SyncStatus.CONFLICT) {
    return (
      <Button
        onClick={handleClick}
        variant="shapeless"
        icon={<CloudArrows20 color="other_red" />}
      />
    );
  }

  // PAUSE — визуально ОТЛИЧНО от зелёного ACTIVE (серый) + tooltip по причине.
  if (syncStatus === SyncStatus.PAUSE) {
    const tooltip = reason ? REASON_TOOLTIP[reason] : 'Синхронизация на паузе';
    return (
      <span title={tooltip}>
        <Button
          onClick={handleClick}
          variant="shapeless"
          icon={<CloudArrows20 color="other_grey" />}
        />
      </span>
    );
  }

  // ACTIVE
  return (
    <Button
      onClick={handleClick}
      variant="shapeless"
      icon={<CloudArrows20 color="other_success" />}
    />
  );
}
